﻿module Client.ContractPage.ChangeOrders.Lines

open FSharpPlus
open Client
open Elmish
open Feliz
open Shared
open PortalLibs.Shared
open Feliz.Bulma
open Shared.Models

let LineRow =
  React.memo<{| Line: ChangeOrderLine |}>(
    name = "LineRow",
    withKey = (fun props -> props.Line.Id.ToString()),
    render = fun props ->
    let line = props.Line
    React.fragment [
      Html.tr [
        let td styles (txt: string) =
          Html.td [
            prop.style styles
            prop.text txt
          ]
        
        prop.children [
          td [style.textAlign.right] (line.Phase |> Option.emptyStrIfNone)
          td [style.textAlign.left] (line.PhaseDescription |> Option.emptyStrIfNone)
          td [style.textAlign.right] (line.CostType |> Option.emptyStrIfNone)
          td [style.textAlign.right] (line.UM |> Option.emptyStrIfNone)
          td [style.textAlign.right] (line.UnitCost |> DisplayNumber.AsCurrency.stdOrEmptyString)
          td [style.textAlign.right] (line.EstUnits |> DisplayNumber.AsNumber.stdOrEmptyString)
          td [style.textAlign.right] (line.HourCost |> DisplayNumber.AsCurrency.stdOrEmptyString)
          td [style.textAlign.right] (line.EstHours |> DisplayNumber.AsNumber.stdOrEmptyString)
          td [style.textAlign.right] (line.EstCost |> DisplayNumber.AsCurrency.stdOrEmptyString)
        ]
      ]
    ]
  )

let LinesTable =
   React.memo<{| Lines: Map<ItemId, ChangeOrderLine list>; ItemId: ItemId |}>(
      name = "LinesTable",
      render = fun props ->
      let lines = props.Lines |> Map.tryFind props.ItemId
      
      match lines with
      | None -> Html.text "Loading lines..."
      | Some lines ->
        Bulma.table [
          prop.style [ style.alignSelf.flexEnd; style.width(length.percent 100); Styles.stickyTableBorder ]
          table.isFullWidth
          table.isHoverable
          prop.children [
            Html.thead [
              Html.tr [
                prop.style (Styles.sticky 100)
                prop.children [
                  let th styles (pct: int) (txt: string) =
                    Html.th [
                      prop.style [
                        yield! styles
                        style.verticalAlign.bottom
                        style.width(length.percent pct)
                        yield! Styles.bottomBorderWithColor(2, "#363636")
                      ]
                      prop.text txt
                    ]
                  th [style.textAlign.right] 10 "Phase"
                  th [style.textAlign.left] 30 "Description"
                  th [style.textAlign.right] 5 "Cost Type"
                  th [style.textAlign.right] 5 "UM"
                  th [style.textAlign.right] 10 "Unit Cost"
                  th [style.textAlign.right] 10 "Est Units"
                  th [style.textAlign.right] 10 "Hour Cost"
                  th [style.textAlign.right] 10 "Est Hours"
                  th [style.textAlign.right] 10 "Est Cost"
                ]
              ]
            ]
            Html.tbody [
              match lines with  
              | [] -> Html.tr [
                Html.td [
                  prop.colSpan 9
                  prop.style [ style.textAlign.center; style.padding(length.px 30, 0)]
                  prop.text "No Change Order Lines"
                ]]
                
              | lines -> yield! lines |>> fun line -> LineRow {| Line = line |} 
            ]
          ]
        ]
  )